import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class SearchRequestValidator {
    public atLeastOneFieldRequired(): ValidatorFn {
      return (formGroup: FormGroup) => {
        const requestFrom = formGroup.get('requestFrom');
        const requestTo = formGroup.get('requestTo');
        const requestDateFrom = formGroup.get('requestDateFrom');
        const requestDateTo = formGroup.get('requestDateTo');
        const requestType = formGroup.get('requestType');
        const requestTitle = formGroup.get('requestTitle');
        const division = formGroup.get('division');
        const chargeAfeCc = formGroup.get('chargeAfeCc');
        const requestStatus = formGroup.get('requestStatus');
        const employee = formGroup.get('employee');
        const approvedBy = formGroup.get('approvedBy');
        const waitingOn = formGroup.get('waitingOn')

        if (requestFrom.value === '' && 
          requestTo.value === '' &&
          requestDateFrom.value === '' &&
          requestDateTo.value === '' &&
          requestType.value === '' &&
          requestTitle.value === '' &&
          division.value === '' &&
          chargeAfeCc.value === '' &&
          requestStatus.value === '' &&
          employee.value === '' &&
          approvedBy.value === '' &&
          waitingOn.value === '') {
          return { atLeastOneFieldRequired: "You must specify a value in at least one of the search fields." };
        }
      };
    }

    public customPatternValidator(config: any): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const check = control.value?.firstName && control.value?.surName 
          ? `${control.value.firstName} ${control.value.surName}` 
          : control.value;
    
        if (!check) return null;
    
        const isValid = new RegExp(config.pattern).test(check);
    
        return !isValid ? { pattern: config.msg } : null;
      };
    }
  }